import mergeTheme from '../theme';

export default {
  Name: 'HeyDoctor',
  BaseUrl: 'https://www.heydoctor.com',
  SquareLogoKey: 'heydoctor-square-transparent.svg',
  LandscapeLogoKey: 'heydoctor-wordmark-dark.svg',
  Theme: mergeTheme({
    colors: {
      primary: '#0054F9',
    },
    typography: {
      baseFontFamily: 'Avenir',
      headerFontFamily: 'Tiempos',
    },
    fonts: [
      {
        name: 'Tiempos',
        url: '//cdn.heydoctor.com/fonts/TiemposHeadlineWeb-Semibold.woff2',
        format: 'woff2',
        weight: 500,
      },
      {
        name: 'Avenir',
        url: '//cdn.heydoctor.com/fonts/avenir/avenir-heavy.woff2',
        format: 'woff2',
        weight: 700,
      },
      {
        name: 'Avenir',
        url: '//cdn.heydoctor.com/fonts/avenir/avenir-medium.woff2',
        format: 'woff2',
        weight: 500,
      },
      {
        name: 'Avenir',
        url: '//cdn.heydoctor.com/fonts/avenir/avenir-book.woff2',
        format: 'woff2',
        weight: 400,
      },
    ],
    components: {
      header: {
        borderWidth: 0,
      },
    },
  }),
  Business: {
    OfficePhone: '(415) 237 1378',
    HelpEmail: 'help@heydoctor.com',
  },
  Social: [
    {
      title: 'Twitter',
      icon: 'twitter',
      link: 'https://twitter.com/heydoctorco',
    },
    {
      title: 'Facebook',
      icon: 'facebook',
      link: 'https://business.facebook.com/heydoctor.com/',
    },
    {
      title: 'Instagram',
      icon: 'instagram',
      link: 'https://www.instagram.com/heydoctor.com/',
    },
    {
      title: 'Reddit',
      icon: 'reddit',
      link: 'https://www.reddit.com/user/hey-doctor/',
    },
    {
      title: 'LinkedIn',
      icon: 'linkedin',
      link: 'https://www.linkedin.com/company/18237606/',
    },
  ],
  Legals: {
    TermsUrl: 'https://heydoctor.com/legals/terms-and-conditions',
    PrivacyUrl: 'https://heydoctor.com/legals/privacy-policy',
  },
} as const;
